import { userIsAdmin, userIsBackOffice } from './userRoleUtils.js'

/**
 * Centre proposé pour une nouvelle demande du client, plutôt que celui de l'utilisateur.
 * Admin et back-office : le centre principal du client. Un manager ne voit que ses centres :
 * on ne lui propose un centre du client que s'il en fait partie (sinon null, son propre
 * centre reste sélectionné et la demande reste visible pour lui).
 *
 * @param {Object} client Données du client (ClientResource.data), avec ses centres
 * @param {Object} authUser Utilisateur connecté, avec ses centres
 * @returns {{ id: number, name: string }|null}
 */
export function centerForClient(client, authUser) {
    const clientCenters = client?.centers?.map((center) => center.data) ?? []
    const principal = clientCenters.find((center) => center.id === client.center_id) ?? clientCenters[0] ?? null

    if (userIsAdmin() || userIsBackOffice()) {
        return principal
    }

    const userCenterIds = (authUser?.centers ?? []).map((center) => center.id)

    return [principal, ...clientCenters].find((center) => center && userCenterIds.includes(center.id)) ?? null
}
